/**
 * The site's sections, by their URL segment, with the name a breadcrumb gives
 * them. Shared by the visible breadcrumb bar (components/PageBreadcrumb) and
 * the BreadcrumbList the prerender writes into each page's head
 * (scripts/prerender/derive-head.ts), so the two cannot disagree.
 */
export const SECTIONS: Record<string, string> = {
  "top-ayurvedic-centers-in-india": "Top Centers",
  "ayurveda-treatments": "Ayurveda Treatments",
  "ayurveda-packages": "Ayurveda Packages",
  "holistic-healing": "Holistic Healing",
};

const JOINING = new Set(["and", "by", "at", "of", "the", "in", "for", "on"]);
/** abbreviations a URL writes in lowercase */
const ABBREVIATIONS: Record<string, string> = { ncr: "NCR" };

/**
 * A centre page's name in the breadcrumb, read from its URL (as the client
 * asked): the slug without "-india", word by word —
 * soukya-international-holistic-health-center-bangalore-india →
 * "Soukya International Holistic Health Center Bangalore". A word the
 * centre's own heading spells specially keeps that spelling (Veda5, AyurVAID,
 * ITC, KARE); joining words stay lowercase. Null for anything that is not a
 * centre page (/top-ayurvedic-centers-in-india/<slug>-india).
 */
export function centreCrumbName(route: string, heading = ""): string | null {
  const m = route.replace(/^\/+|\/+$/g, "").match(/^top-ayurvedic-centers-in-india\/([a-z0-9-]+)-india$/);
  if (!m) return null;
  // mixed case, a digit, or a short all-caps name — not just a shouted word
  const special = (w: string) => /\d/.test(w) || (/[A-Z]/.test(w.slice(1)) && /[a-z]/.test(w)) || (/^[A-Z]{2,4}$/.test(w));
  const spelled = new Map(
    heading.split(/[^A-Za-z0-9]+/).filter((w) => w && special(w)).map((w) => [w.toLowerCase(), w] as const)
  );
  return m[1]
    .split("-")
    .filter(Boolean)
    .map((w, i) => spelled.get(w) ?? ABBREVIATIONS[w] ?? (i > 0 && JOINING.has(w) ? w : w[0].toUpperCase() + w.slice(1)))
    .join(" ");
}
